var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7738_266)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0875 44C12.5125 44 10.0375 40.8375 8.25001 38.0875C3.71251 31.075 2.75001 22.275 6.05001 17.1875C8.25001 13.75 11.825 11.6875 15.2625 11.6875C17.05 11.6875 18.5625 12.2375 19.8 12.65C20.7625 13.0625 21.725 13.3375 22.6875 13.3375C23.5125 13.3375 24.2 13.0625 25.1625 12.65C26.4 12.2375 27.9125 11.6875 29.975 11.6875C33 11.6875 36.1625 13.3375 38.3625 16.0875C38.6375 16.3625 38.775 16.775 38.6375 17.1875C38.5 17.6 38.3625 17.875 37.95 18.15C35.475 19.525 34.1 22 34.375 24.75C34.5125 27.6375 36.3 29.975 38.9125 30.9375C39.325 31.075 39.6 31.35 39.7375 31.7625C39.875 32.175 39.875 32.45 39.7375 32.8625C38.775 34.925 38.3625 35.8875 37.125 37.675C35.0625 40.7 32.5875 43.8625 29.2875 43.8625C27.775 43.8625 26.8125 43.45 25.9875 43.0375C25.1625 42.625 24.3375 42.2125 22.6875 42.2125C21.175 42.2125 20.35 42.625 19.3875 43.0375C18.5625 43.5875 17.6 44 16.0875 44Z",
    fill: "#CACFE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5875 11.9625C21.45 11.9625 21.45 11.9625 21.3125 11.9625C20.625 11.9625 20.075 11.4125 19.9375 10.8625C19.525 8.52505 20.35 5.77505 22.1375 3.57505C23.7875 1.51255 26.5375 0.137549 29.0125 -0.137451C29.7 -0.137451 30.3875 0.275049 30.525 1.10005C30.9375 3.57505 30.1125 6.18755 28.325 8.38755C26.8125 10.5875 24.0625 11.9625 21.5875 11.9625Z",
    fill: "#CACFE2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7738_266"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.5e4c957d35aa98ee3ed0047011ea93c6.svg";
export { ForwardRef as ReactComponent };